export const surveyTemplateQueryKeys = {
  all: ['surveyTemplates'] as const,

  // Templates by tenant
  templatesByTenant: (tenantId: string) =>
    [...surveyTemplateQueryKeys.all, 'byTenant', tenantId] as const,

  // Individual template
  template: (tenantId: string, templateId: string) =>
    [...surveyTemplateQueryKeys.all, 'template', tenantId, templateId] as const,

  // Template with questions (for builder)
  templateWithQuestions: (tenantId: string, templateId: string) =>
    [...surveyTemplateQueryKeys.template(tenantId, templateId), 'withQuestions'] as const,
};
